import { MtPackage } from "server/models"
import {
    ActiveInactive,
    OrderType,
    YesNo,
    NoneValueUnlimited,
    ZeroValueUnlimited,
    OneValueUnlimited,
    KeyValue,
    PrivatePublicNonPublic,
} from "client/utils"


export interface PackageSettings {
    // drive
    driveSpace: ZeroValueUnlimited
    driveSpaceValue: number
    cloudDrivesAllowed: YesNo

    // okr
    okrModuleAccess: YesNo

    // rrs
    rrsRiskSpaceModuleAccess: YesNo
    rrsRiskSpaceTemplates: NoneValueUnlimited
    rrsRiskSpaceTemplatesValue: number

    // study
    studyModuleAccess: YesNo

    // task
    taskModuleAccess: YesNo
    subTaskModuleAccess: YesNo
    taskGrantView: YesNo
    taskKanbanView: YesNo

    // project
    projectModuleAccess: YesNo
    projects: OneValueUnlimited
    projectsValue: number
    subProjects: NoneValueUnlimited
    subProjectsValue: number
    projectTeamMembers: OneValueUnlimited
    projectTeamMembersValue: number

    // cc
    ccModuleAccess: YesNo
    ccAccountComplianceSets: NoneValueUnlimited
    ccAccountComplianceSetsValue: number
    ccLibraryComplianceSets: NoneValueUnlimited
    ccLibraryComplianceSetsValue: number
    ccCompliantItems: NoneValueUnlimited
    ccCompliantItemsValue: number
    ccProjectCompliantItems: NoneValueUnlimited
    ccProjectCompliantItemsValue: number
    ccResponseModuleAccess: YesNo
    ccApprovalModuleAccess: YesNo
    ccRequirementsModuleAccess: YesNo
    ccRequirements: NoneValueUnlimited
    ccRequirementsValue: number

    // lifecycle
    lifecycleModuleAccess: YesNo
    lifecycles: NoneValueUnlimited
    lifecyclesValue: number
    subLifecycles: NoneValueUnlimited
    subLifecyclesValue: number

    // sil
    silModuleAccess: YesNo
    silAccountDevices: NoneValueUnlimited
    silAccountDevicesValue: number
    silAccountSubsystems: NoneValueUnlimited
    silAccountSubsystemsValue: number
    silSafetyFunctions: NoneValueUnlimited
    silSafetyFunctionsValue: number
    silCalculations: NoneValueUnlimited
    silCalculationsValue: number
    silReports: NoneValueUnlimited
    silReportsValue: number

    // qid
    qidModuleAccess: YesNo

    // markov
    markovModuleAccess: YesNo
}

export type PackageActiveCell = {
    packageId: number
    column: keyof MtPackage | keyof PackageSettings | "allowedAccounts"
}

export interface PackageProps {
    packageId: number
}

export type PackageValidation = { [key in keyof MtPackage]?: string}
export type ChangePackageSettings = KeyValue<PackageSettings>

export interface PackageList { [packageId: number]: MtPackage }
export interface PackageFilters {
    status?: ActiveInactive
    visibility?: PrivatePublicNonPublic
    search?: string
}

export interface PackageAllowedList { [packageId: number]: number[] } // { packageId: accountId[] }

export interface PackageState {
    packageList: PackageList
    packageIds: readonly number[]
    packageEdit: MtPackage
    packageSettings: PackageSettings

    packageAllowed: PackageAllowedList
    activeCell: PackageActiveCell

    sortColumn: keyof MtPackage
    sortOrder: OrderType
    filters: PackageFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const PACKAGE_LIST = "PACKAGE_LIST"
export const PACKAGE_IDS = "PACKAGE_IDS"
export const PACKAGE_EDIT = "PACKAGE_EDIT"
export const PACKAGE_SETTINGS = "PACKAGE_SETTINGS"

export const PACKAGE_ALLOWED = "PACKAGE_ALLOWED"
export const PACKAGE_ACTIVE_CELL = "PACKAGE_ACTIVE_CELL"

export const PACKAGE_SORT = "PACKAGE_SORT"
export const PACKAGE_FILTERS = "PACKAGE_FILTERS"

export const PACKAGE_RELOAD_LIST = "PACKAGE_RELOAD_LIST"
export const PACKAGE_RELOAD_EDIT = "PACKAGE_RELOAD_EDIT"
